import {Dispatch, SetStateAction, MutableRefObject, useCallback} from "react"
import { createRow } from "../utils/creator-utils"
import {I18nFamily as GedcomFamily} from "../model/gedcom-family"


export function useCommonCallbacks(
    lastFamilyId: MutableRefObject<number>,
    setFamiliesData: Dispatch<SetStateAction<GedcomFamily[]>>,
    setActiveIndex: Dispatch<SetStateAction<number>>,
    dismissFamiliesAnnounce: () => void
) {
    const switchTab = useCallback((targetRowId: string) => {
        setActiveIndex(prev => (prev === 0 ? 1 : 0))
        dismissFamiliesAnnounce()
        requestAnimationFrame(() => {
            const row = document.getElementById(targetRowId)
            const prevRow = row?.previousElementSibling as HTMLElement
            if (prevRow)
                prevRow.scrollIntoView({ behavior: "smooth", block: "start" })
            else
                row!.scrollIntoView({ behavior: "smooth", block: "start" })
        })
    }, [setActiveIndex, dismissFamiliesAnnounce])

    const startFamily = useCallback((fatherId: string, motherId: string) => {
        setFamiliesData(prev => {
            if (prev.length === 1 && !prev[0].husbandId && !prev[0].wifeId) {
                const updated = [...prev]
                updated[0] = new GedcomFamily({ ...updated[0], husbandId: fatherId, wifeId: motherId, pristine: false })
                return updated
            }
            const newFamily = createRow<GedcomFamily>(lastFamilyId, prev.length, GedcomFamily)
            return [...prev, new GedcomFamily({ ...newFamily, husbandId: fatherId, wifeId: motherId, pristine: false })]
        })
    }, [setFamiliesData, lastFamilyId])

    return { switchTab, startFamily }
}
